// extracted by mini-css-extract-plugin
module.exports = {"block":"ScoutingMock_block__YOAC9","tabs":"ScoutingMock_tabs__lirAc","edit":"ScoutingMock_edit__bDaCe","report":"ScoutingMock_report__0BD_4","skills":"ScoutingMock_skills__G__uR"};